// HOLDINGS

/**
 * Different allocation modes, specifically for portfolios. Dictates the source of truth
 * when it comes to updating those portfolios. Portfolios allocated by units need those units
 * to stay consistent - a change in the holding prices means the dollars amount need to be
 * re-calculated (both for the individual holdings and the total portfolio's size).
 */
export enum HoldingAllocationMode {
  Units = 'UNITS',
  Weight = 'WEIGHT',
}

// Keys based on the "PortfolioHolding" type
export enum PORTFOLIO_HOLDINGS_KEYS {
  ADVISORY_FEE = 'advisoryFee',
  DOLLARS = 'dollars',
  FLAGS = 'flags',
  NAME = 'name',
  SYMBOL = 'symbol',
  UNITS = 'units',
  WEIGHT = 'weight',
  ALTERNATIVES = 'alt',
}

// Enums representing the Portfolio Holdings Table Columns that are not keys of the "PortfolioHolding" type
export enum PORTFOLIO_HOLDINGS_OTHER_TABLE_COLUMNS {
  ACTION_COMPARE_ALTERNATIVES = 'actionCompareAlternarives',
  ACTION_DELETE = 'actionDelete',
}

// METRICS

// Enums representing the possible Portfolio Metrics Table Columns
export enum PORTFOLIO_METRICS_TABLE_COLUMNS {
  ONE_YEAR = 'ONE_YEAR',
  THREE_YEAR = 'THREE_YEAR',
  BETA = 'BETA',
  CLASSIFICATION = 'CLASSIFICATION',
  OBJECTIVE = 'OBJECTIVE',
  INCEPTION_DATE = 'INCEPTION_DATE',
  TNA = 'TNA',
  CURRENCY = 'CURRENCY',
  CODE = 'CODE',
  MER = 'MER',
  NAME = 'NAME',
  FIRM_NAME = 'FIRM_NAME',
  VINTAGE = 'VINTAGE',
  STATUS = 'STATUS',
  COMMITMENT = 'COMMITMENT',
  GP_COMMITMENTS_TO_FUND = 'GP_COMMITMENTS_TO_FUND',
  CALLED = 'CALLED',
  DISTRIBUTED = 'DISTRIBUTED',
  REMAINING = 'REMAINING',
  DURING_INVESTMENT_PERIOD = 'DURING_INVESTMENT_PERIOD',
  POST_INVESTMENT_PERIOD = 'POST_INVESTMENT_PERIOD',
  CHARGE_FREQUENCY = 'CHARGE_FREQUENCY',
  HURDLE_RATE = 'HURDLE_RATE',
  CARRIED_INTEREST = 'CARRIED_INTEREST',
  GP_CATCH_UP_RATE = 'GP_CATCH_UP_RATE',
  FUND_FORMATION_COST = 'FUND_FORMATION_COST',
  NET_IRR = 'NET_IRR',
  MEDIAN_BENCHMARK_IRR = 'MEDIAN_BENCHMARK_IRR',
  QUARTILE = 'QUARTILE',
}

// LEGACY ENUMS

export enum PORTFOLIO_METRICS_FIELDS {
  SIZE,
  HOLDINGS,
  YEAR_ONE,
  YEAR_THREE,
  YEAR_FIVE,
  MER,
}

export enum PORTFOLIO_TABLE_COLUMNS {
  ID = 'ID',
  CONTACTS = 'CONTACTS',
  NAME = 'NAME',
  LOCK = 'LOCK',
  GROUP = 'GROUP',
  PLAN_ACCOUNT = 'PLAN_ACCOUNT',
  RISK_PROFILE = 'RISK_PROFILE',
  OWNERS = 'OWNERS',
  LAST_MODIFIED = 'LAST_MODIFIED',
  HOLDINGS = 'HOLDINGS',
  SHOW_DETAILS = 'SHOW_DETAILS',
  COMPARE = 'COMPARE',
  MENU_TOGGLE = 'MENU_TOGGLE',
  WARNING = 'WARNING',
}

export enum PORTFOLIO_TABLE_COLUMNS_KEYS {
  ID = 'id',
  ACTION_COMPARE = 'action-compare',
  ACTION_MENU_TOGGLE = 'action-menu-toggle',
  CONTACTS = 'contacts',
  ENTERPRISE_GROUP = 'enterpriseGroups',
  LOCK = 'lock',
  WARNING = 'warning',
  NAME = 'name',
  PLAN_ACCOUNT = 'planning',
  RISK_PROFILE = 'riskProfile',
  SAVED_AT = 'dates.savedAt',
}
